import React, { Component } from 'react';
import './polaroid-gallery.css';

class PurePolaroidGallery extends Component {

  render(){
   
    const { photos } = this.props
    console.log("selectedPhoto", this.props.selectedPhoto)
    return (
      <ul className="gallery">
        {photos.map((photo, i) => this.renderPhoto(i, photo))}
      </ul>
    ) 
  } 


  renderPhoto = (position, photo) => {
      const {photos, selectedPhoto, transform, onClick, imageWidth, imageHeight} = this.props

      const { rotate, top, left } = transform[position]
      const isSelected = selectedPhoto === position
      const active = isSelected ? "active" : ""
      const rot = isSelected ? 0 : rotate
      const widthImage = !isSelected ? 180 : imageWidth
      const heightImage = !isSelected ? 180 : imageHeight
      const srcImage = isSelected ? photo.src : photo.thumbnail
      const translateX = isSelected ? (400-left) : 0
      const translateY = isSelected ? (-top) : 0
      let zIndex = (position + (photos.length-1) - (selectedPhoto || 0)) % photos.length
      if (isSelected) {
        zIndex = 0; //(position + (photos.length-1) - (selectedPhoto || 0)-1) % photos.length
      }
      const cssTransform = 'rotate('+rot+'deg) translate(' + translateX + 'px, ' + translateY + 'px)'

      return (
        <li key={position} draggable="true"
              className={active}
              style={{transform: cssTransform, zIndex, top, left}} 
              onClick={() => onClick(position)} >
              <div style ={{backgroundImage: `url(${srcImage})`, backgroundPosition:'center', backgroundSize:'cover', display:'block',  height: heightImage, width : widthImage, transition: 'width 0.5s ease'}}/>
        </li>
      )
    }
}

export class PolaroidGallery extends Component {
  
    state = {
      selectedPhoto: null
    }
    transform = []
   
    componentWillReceiveProps(nextProps){

      setTimeout(() => this.handleClick(nextProps.photos.length-1), 2000)
    }

    randomTransform(){
      
      return {
        rotate: Math.round(Math.random()*90-45),
        top: Math.round(this.props.top),
        left: Math.round(Math.random()*50-25),
      }  
    }
    
    handleClick = (position) => {
      this.setState({selectedPhoto:position})
    }

    render(){
      const {photos} = this.props;
        
      if (photos.length === 0) return null
   
      if (this.transform.length === 0) 
      {
        for (let i=0; i<1000; i++){
          this.transform.push(this.randomTransform())
        }
      }
     
      return <PurePolaroidGallery {...this.props} {...this.state} transform={this.transform} onClick={this.handleClick} />
    }
    
  }
  


// WEBPACK FOOTER //
// ./src/components/Galleries/PolaroidGallery/index.js